import React from 'react'

const SVG = ({
  style = {},
  fill = '#FFFFFF',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 8 13'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <path
      fill={fill}
      d='M7.7,12.7c0.4-0.4,0.4-1.1,0-1.5c0,0,0,0,0,0L2.6,6.5l5.1-4.7c0.4-0.4,0.4-1,0.1-1.5c0,0,0,0,0,0
	c-0.4-0.4-1.1-0.4-1.5,0L0.3,5.7C0,6.1,0,6.5,0,6.5l0,0v0c0,0.1,0,0.4,0.3,0.7l5.9,5.5C6.6,13.1,7.3,13.1,7.7,12.7z'
    />
  </svg>
)

export default SVG
